import { render, staticRenderFns } from "./UsagesList.vue?vue&type=template&id=3a3f171c&"
import script from "./UsagesList.vue?vue&type=script&lang=js&"
export * from "./UsagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports